/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_WebInputs */



/**
* | output |
* | --- |
* | "Web Application (Google Chrome)" |
*
* @param {Signup_Compare_WebInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_web = /** @type {((inputs?: Signup_Compare_WebInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_WebInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
	return /** @type {LocalizedString} */ ("Web Application (Google Chrome)")
});